module.exports = __webpack_public_path__ + "static/media/displayIcon.634c9c9b.svg";